import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "invisible",
  ref: "list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactItem = _resolveComponent("ContactItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (entity) => {
      return (_openBlock(), _createBlock(_component_ContactItem, {
        key: entity.id,
        contact: entity,
        class: "mb-4 last:mb-0"
      }, null, 8, ["contact"]))
    }), 128))
  ], 512))
}